import { FilterOptionKeys, FilterOptions, SearchParams } from '@mybestbrands/types';
import { isAnyFilterSelected } from '@/app/helpers/searchparams';
import React from 'react';
import { SelectedFilter } from '@/app/ui/components/filters/SelectedFilter';
import { ResetSelectedFilters } from '@/app/ui/components/filters/ResetSelectedFilters';

interface Props {
  facets: FilterOptions | null;
  searchParams: SearchParams;
  localePath: string;
  excludedFilters: FilterOptionKeys[];
}

export function SelectedFiltersContainerWrapper({ facets, searchParams, excludedFilters }: Props) {
  const anyFilterSelected = isAnyFilterSelected(searchParams, excludedFilters);
  if (!anyFilterSelected) return null;

  return (
    <>
      <div className="d-flex flex-wrap mb-4 false">
        {Object.entries(searchParams?.filters ?? {}).map(([key, value]) => {
          //We do not want to include all the filters in the selected filters
          if (excludedFilters.includes(key as FilterOptionKeys)) return null;

          if (key === FilterOptionKeys.SALE && value) return <SelectedFilter key={key} filterKey={key} name={'sale'} />;
          if (key === FilterOptionKeys.COUPON && value)
            return <SelectedFilter key={key} filterKey={key} name={'coupon'} />;
          if (key === FilterOptionKeys.HOTTEST_SALE && value)
            return <SelectedFilter key={key} filterKey={key} name={'hottest_sale'} />;
          if (key === FilterOptionKeys.PRICE && Array.isArray(value) && value.length) {
            const [min, max] = value as string[];
            return <SelectedFilter key={key} filterKey={key} name={`${min}€ - ${max}€`} />;
          }
          if (Array.isArray(value)) {
            return value.map((v) => (
              <div key={v}>
                <SelectedFilter
                  filterKey={key as FilterOptionKeys}
                  name={v}
                  facet={facets?.[key as FilterOptionKeys]}
                />
              </div>
            ));
          }
        })}
        <ResetSelectedFilters />
      </div>
    </>
  );
}
